export default __webpack_public_path__ + "static/media/point-restricted.8b70e099.svg";